import * as React from 'react'

function IconAttach(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={67}
      height={61}
      viewBox="0 0 67 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 39.608V21.756C5 12.5 12.485 5 21.722 5h23.556c9.236 0 16.721 7.507 16.721 16.756v17.852M33 56V30"
        stroke={props.color ? props.color : '#F4BA27'}
        strokeWidth={10}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M44 35l-6.95-8.322a4.595 4.595 0 00-7.1 0L23 35"
        stroke={props.color ? props.color : '#F4BA27'}
        strokeWidth={10}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconAttach
